import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import SectionHeader from '../../components/SectionHeader';
import FormCard from '../../components/FormCard';
import Button from '../../components/Button';
import { HiOutlineArrowRightOnRectangle } from 'react-icons/hi2';
import { useUser } from 'hooks/useUser';

export default function AccountView(): ReactElement {
  const [userProfile, signOut] = useUser();

  return (
    <>
      <SectionHeader title="Account" />
      <div className="cr-flex cr-flex-col cr-rounded-lg cr-bg-white cr-p-2 cr-text-center cr-shadow-md md:cr-w-[640px] md:cr-text-left">
        <div className="cr-p-3">
          <div className="cr-space-y-4">
            <div className="cr-flex cr-flex-col">
              <label className="cr-mb-1 cr-text-lg cr-font-medium cr-text-gray-700">User Name</label>
              <div className="cr-rounded cr-bg-gray-50 cr-p-2 cr-text-lg cr-text-gray-900">
                {userProfile.user_name || 'Not provided'}
              </div>
            </div>

            <div className="cr-flex cr-flex-col">
              <label className="cr-mb-1 cr-text-lg cr-font-medium cr-text-gray-700">Email</label>
              <div className="cr-rounded cr-bg-gray-50 cr-p-2 cr-text-lg cr-text-gray-900">
                {userProfile.email_address || 'Not provided'}
              </div>
            </div>

            <div className="cr-flex cr-flex-col">
              <label className="cr-mb-1 cr-text-lg cr-font-medium cr-text-gray-700">Team</label>
              <div className="cr-rounded cr-bg-gray-50 cr-p-2 cr-text-lg cr-text-gray-900">
                {userProfile.team?.name || 'Not provided'}
              </div>
            </div>
          </div>

          <div className="cr-mt-6">
            <Button
              onClick={() => signOut()}
              icon={<HiOutlineArrowRightOnRectangle className={'cr-size-7'} />}
              className="cr-border-red-600 cr-bg-red-600 cr-text-black hover:cr-bg-red-700"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {/* The team's Nimbus recording files, and the way to bring a run that
          never reached the server into a session. */}
      <FormCard className="cr-mt-4">
        <div className="cr-flex cr-flex-col cr-gap-2 cr-p-3 md:cr-flex-row md:cr-items-center md:cr-justify-between">
          <div className="cr-flex cr-flex-col cr-text-left">
            <span className="cr-text-lg cr-font-medium cr-text-gray-700">Recordings</span>
            <span className="cr-text-sm cr-text-gray-500">
              Recording files uploaded from your team&apos;s phones. Check which of their runs are on the server,
              and import the ones that are missing into a session.
            </span>
          </div>
          <Link
            to="/account/episodes"
            className="cr-shrink-0 cr-rounded-md cr-bg-blue-600 cr-px-3 cr-py-1.5 cr-text-sm cr-font-medium cr-text-white cr-no-underline hover:cr-bg-blue-700"
          >
            Open
          </Link>
        </div>
      </FormCard>
    </>
  );
}
